import {StaticImage, StaticPath} from '@/static/common';

export const FooterInfo = {
  phone: '159-1887-4225',
  miniprogramCode: `${StaticPath.OSS_PATH}${StaticImage.MINIPROGRAM_WECHAT_CODE}`,
  officialCode: `${StaticPath.OSS_PATH}${StaticImage.OFFICIAL_WECHAT_CODE}`,
  serviceNum3Code: `${StaticPath.OSS_PATH}${StaticImage.SERVICE_NUM3_WECHAT_CODE}`,
  shopAddress: [
    '珠江新城店（三银大厦）天河区珠江新城华就路12号三银大厦706',
    '广州东站店（保利中汇）林和西路157号保利中汇A座写字楼806',
    '华师店（光大银行大厦）天河北路689号光大银行大厦505',
    '客村店（会展时代）新港中路丽影广场Ｃ区会展时代写字楼1508',
    '淘金店（正佳东方）越秀区环市东路370-372号正佳东方国际广场46楼4615房',
    '体育西路店（中盈大厦）天河区华强路9号保利克洛维.中盈大厦 2408',
    '汉溪长隆店（奥园城市天地）番禺区奥园城市天地9区4栋01-03',
    '越秀公园店（锦洲国际商务中心）广州市越秀区解放北路899号锦洲国际商务中心 508-6',
  ],
};
